// Theme state (light/dark) for the NavarchAI design system.
// Priority: saved choice → device prefers-color-scheme → light.
// The value is stamped on <html data-theme> so the token sets in
// navarchTheme.js apply everywhere, including portaled overlays.
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'navarch-theme'; // same key the design mockup uses

export function getInitialTheme() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark') return saved;
  } catch {
    // storage unavailable (private mode) — fall through to the device hint
  }
  try {
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return 'dark';
    }
  } catch {
    // matchMedia unavailable — default to light
  }
  return 'light';
}

export function useTheme() {
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      // not persistable — the session still works, just resets next visit
    }
  }, [theme]);

  const toggle = () => setTheme(t => (t === 'dark' ? 'light' : 'dark'));
  return { theme, toggle };
}
